import SysErrorCodesList from "../component/SysErrorCodesList";
import React from "react";

const SysErrorCodesListContainer = ({ pageId }) => (<SysErrorCodesList pageId={ pageId } />)

export default SysErrorCodesListContainer;